<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->
      <div class="popup-content">
        <!-- 背景 -->
        <div class="content-bg">
          <img src="@/assets/images/YuliApp/intro/pic_bg.png" />
        </div>

        <!-- 文字内容 -->
        <div class="content-text">
          <div class="pos content-text-name">Details</div>

          <div class="pos content-text-body">
            20 gods made great contributions to the world of 30086.
            <br /><br />Their memories will be immortalised in the Terra, and
            the Yuli will have a certain chance to obtain their memories when
            they purify the Terras, and will be able to exchange mysterious
            items.
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose">
        <img src="@/assets/images/YuliApp/memory/icon_del.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import hookStoreState from "@/utils/useState.js";

export default {
  setup(props, ctx) {
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });
    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(statusBarHeight.value + window.innerHeight * 0.1);

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close");
    };

    return {
      popup_top,
      handleClose,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    &-content {
      width: 100%;

      .content {
        &-bg {
          width: 351px;
          height: 495px;
        }

        &-text {
          color: #626e8f;
          font-size: 15px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;

          .pos {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
          }

          &-name {
            top: 37px;
            font-size: 18px;
            font-weight: 500;
            text-align: center;
            line-height: 22px;
          }

          &-body {
            top: 97px;
            width: 245px;
            font-size: 15px;
            line-height: 20px;
          }
        }
      }
    }

    &-btn {
      margin-top: 28px;
      width: 40px;
      height: 40px;
    }
  }
}
</style>
